export const WIX_HOME_URL =
  process.env.REACT_APP_WIX_HOME_URL || 'https://demo.musescabinets.com'

export const PRODUCT_IMAGE_BASE_URL =
  process.env.REACT_APP_PRODUCT_IMAGE_BASE_URL
